import { memo } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import LineFacebookIcon from 'LuxKit/Icons/line/LineFacebookIcon'
import LineInstagramIcon from 'LuxKit/Icons/line/LineInstagramIcon'
import LineYoutubeIcon from 'LuxKit/Icons/line/LineYoutubeIcon'
import LineTiktokIcon from 'LuxKit/Icons/line/LineTiktokIcon'
import ClickableLink from 'components/Common/Clickable/ClickableLink'
import BodyText from 'LuxKit/Typography/BodyText'
import Group from 'components/utils/Group'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'

const IconsButton = styled(ClickableLink)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${rem(46)};
  width: ${rem(46)};
  color: ${props => props.theme.palette.neutral.surface.normalContrast};
  border-radius: ${props => props.theme.borderRadius.round};
  border: 1px solid ${props => props.theme.palette.neutral.surface.lightForeground};

  @media print {
    &[href]::after {
      content: " (" attr(href) ")";
    }
  }
`

function FollowUsLinks() {
  const intl = useIntl()

  const title = intl.formatMessage({
    id: 'FmivnBxPC1IwFuy9Sjk4',
    defaultMessage: 'Follow us',
  })

  return (
    <VerticalSpacer gap={16}>
      <BodyText variant="large" as="h4" weight="bold" align="center" tabletAlign="start">
        {title}
      </BodyText>
      <Group direction="horizontal" wrap="wrap" gap={8}>
        <IconsButton href="https://www.facebook.com/luxuryescapes" target="_blank" rel="noreferrer noopener">
          <LineFacebookIcon size="S" />
        </IconsButton>
        <IconsButton href="https://www.instagram.com/luxury.escapes/" target="_blank" rel="noreferrer noopener">
          <LineInstagramIcon size="S" />
        </IconsButton>
        <IconsButton href="https://www.youtube.com/channel/UCm7SgjHCUgYmgMv0uQex0mQ" target="_blank" rel="noreferrer noopener">
          <LineYoutubeIcon size="S" />
        </IconsButton>
        <IconsButton href="https://www.tiktok.com/@luxury.escapes" target="_blank" rel="noreferrer noopener">
          <LineTiktokIcon size="S" />
        </IconsButton>
      </Group>
    </VerticalSpacer>
  )
}

export default memo(FollowUsLinks)
